// extracted by mini-css-extract-plugin
export var container = "_5i-0";
export var fallback = "_5i-5";
export var fallbackIcon = "_5i-6";
export var hidden = "_5i-2";
export var image = "_5i-3";
export var loaded = "_5i-4";
export var placeholder = "_5i-1";